module.exports = __webpack_public_path__ + "static/media/o4.98d97286.png";